// extracted by mini-css-extract-plugin
export default {"splashScreen":"bk0wqiU0YeP6OjhesAUG"};